import { render, staticRenderFns } from "./GrantDescription.vue?vue&type=template&id=273d7ccd&scoped=true"
import script from "./GrantDescription.vue?vue&type=script&lang=js"
export * from "./GrantDescription.vue?vue&type=script&lang=js"
import style0 from "./GrantDescription.vue?vue&type=style&index=0&id=273d7ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d7ccd",
  null
  
)

export default component.exports